module.exports = __webpack_public_path__ + "static/media/money.5702cc5e.svg";